export const semantic = {
  transitionDuration: '0.2s',
  topbar: {
    item: {
      textColor: '{primary.contrastColor}',
    },
  },
  focusRing: {
    width: '0',
    style: 'none',
    color: 'transparent',
    offset: '0',
    shadow: 'none',
  },
  disabledOpacity: '0.6',
  iconSize: '1rem',
  anchorGutter: '2px',
  primary: {
    100: '{colors.main}',
  },
  colorScheme: {
    light: {
      primary: {
        color: '{colors.main}',
        hoverColor: '{colors.calypso}',
      },
      surface: {
        color: '{colors.white}',
      },
    },
  },
  formField: {
    paddingX: '0.75rem',
    paddingY: '0.5rem',
    sm: {
      fontSize: '0.875rem',
      paddingX: '0.625rem',
      paddingY: '0.375rem',
    },
    lg: {
      fontSize: '1.125rem',
      paddingX: '0.875rem',
      paddingY: '0.625rem',
    },
    borderRadius: '{border.radius.sm}',
    focusRing: {
      width: '0',
      style: 'none',
      color: 'transparent',
      offset: '0',
      shadow: 'none',
    },
    transitionDuration: '{transition.duration}',
  },
  list: {
    padding: '0.25rem 0.25rem',
    gap: '2px',
    header: {
      padding: '0.5rem 1rem 0.25rem 1rem',
    },
    option: {
      padding: '0.5rem 0.75rem',
      borderRadius: '{border.radius.sm}',
      selectedColor: '{primary.contrastColor}',
    },
    optionGroup: {
      padding: '0.5rem 0.75rem',
      fontWeight: '600',
    },
  },
  content: {
    borderRadius: '{border.radius.sm}',
  },
  mask: {
    transitionDuration: '0.15s',
  },
  navigation: {
    list: {
      padding: '0.25rem 0.25rem',
      gap: '2px',
    },
    item: {
      padding: '0.5rem 0.75rem',
      borderRadius: '{border.radius.sm}',
      gap: '0.5rem',
    },
    submenuLabel: {
      padding: '0.5rem 0.75rem',
      fontWeight: '600',
    },
    submenuIcon: {
      size: '0.875rem',
    },
  },
  overlay: {
    select: {
      borderRadius: '{border.radius.sm}',
      shadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)',
    },
    popover: {
      borderRadius: '{border.radius.sm}',
      padding: '0.75rem',
      shadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)',
    },
    modal: {
      borderRadius: '{border.radius.xl}',
      padding: '1rem',
      shadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)',
    },
    navigation: {
      shadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)',
    },
  },
};
